// Adds the product name HTTP header to all Ajax requests.
define('configuration/product.name.configuration',['require','exports','module','jquery','fukit'],function(require, exports, module) {
  //prettier-ignore
  var jQuery = require('jquery'),
      config = require('fukit').config;

  var ProductNameConfiguration = {
    radioEvents: {
      'app configure': 'onAppConfigure',
    },

    onAppConfigure: function() {
      jQuery.ajaxSetup({
        headers: {
          'Product-Name': config.get('APP_PRODUCT_NAME'),
        },
      });
    },
  };

  module.exports = ProductNameConfiguration;
});

